import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export interface StabilityRow {
  product_id: string;
  optimization_number: number;
  delta_7d_pct: number | null;
  delta_14d_pct: number | null;
  delta_28d_pct: number | null;
}

export function useStability(feedId: string | null) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['optimization-stability', feedId, user?.id],
    queryFn: async (): Promise<StabilityRow[]> => {
      if (!feedId || !user?.id) return [];
      const { data, error } = await supabase.rpc('get_optimization_stability', {
        p_feed_id: feedId,
        p_user_id: user.id,
        p_limit: 1000,
      });
      if (error) throw error;
      return (data ?? []) as StabilityRow[];
    },
    enabled: !!feedId && !!user?.id,
    staleTime: 120_000,
  });
}

/** Build a lookup map keyed by `${product_id}:${optimization_number}`. */
export function buildStabilityMap(rows: StabilityRow[]): Map<string, StabilityRow> {
  const m = new Map<string, StabilityRow>();
  for (const r of rows) m.set(`${r.product_id}:${r.optimization_number}`, r);
  return m;
}
